import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DownloadFileComponent } from "./download-file/download-file.component";
import { SummaryMedicalCreditComponent } from "./admin-request-flow/summary-medical-credit/summary-medical-credit.component";
import { UploadFileComponent } from "./employee-request-flow/upload-file/upload-file.component";
import { ModalApprovedComponent } from "./admin-request-flow/modals/modal-approved/modal-approved.component";
import { ModalAlertaComponent } from "./modal-alerta/modal-alerta.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { SpinnerComponent } from "./spinner/spinner.component";


@NgModule({
    declarations: [
        DownloadFileComponent,
        SummaryMedicalCreditComponent,
        UploadFileComponent,
        ModalApprovedComponent,
        ModalAlertaComponent,
        SpinnerComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule
    ],
    exports: [
        DownloadFileComponent,
        SummaryMedicalCreditComponent,
        UploadFileComponent,
        ModalApprovedComponent,
        ModalAlertaComponent,
        SpinnerComponent
    ]
})
export class BenefitApplicationModule { }